import { z } from 'zod'
import { permissionsSchema } from './permission'

export const roleSchema = z.object({
    created_at: z.coerce.date(),
    name: z.string(),
    permissions: permissionsSchema.nullable(),
    scope: z.string().nullable(),
    scope_for_human: z.string(),
    title: z.string(),
    updated_at: z.coerce.date(),
    uuid: z.string().uuid(),
})

export const rolesSchema = z.array(roleSchema)
